<template>
  <div class="inner show-container">
    <div class="capsule" v-if="voice">
      <h3>
        <strong>{{ voice.type }}:</strong> <small>{{ voice.topic }} ({{ voice.city }})</small>
      </h3>
      <div class="row">
        <div class="col-9 col-12-small">         
          <strong>details:</strong>
          <p class="box" v-html="voice.text" v-linkified />
          <span v-if="admin">
            <span v-if="voice.email">from <a :href="'mailto:'+voice.email">{{ voice.email }} </a></span>
            <span v-if="voice.email">(anonymous={{voice.anonymous}})</span><br /><br />
          </span>
        </div>
        <div v-if="admin" class="col-3 col-12-small">
          <ul class="alt">
            <li>
              <a v-on:click="moveToTop" class="button primary fit small"
                >Move to Top</a
              >
            </li>
            <li>
              <a v-on:click="moveToBottom" class="button primary fit small"
                >Move to Bottom</a
              >
            </li>
            <li>
              <a v-on:click="deleteVoice" class="button primary fit small"
                >delete</a
              >
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div v-else></div>
  </div>
</template>

<style scoped lang="scss">
.capsule {
  padding: 0.5rem;
}
small {
  font-size: large;
}
</style>

<script>
import axios from 'axios';
import linkify from 'vue-linkify';

const IS_PRODUCTION = process.env.NODE_ENV === 'production';

const APIUrl = IS_PRODUCTION
  ? 'https://funtiny.appspot.com/'
  : 'http://localhost:5000';

export default {
  name: 'show',
  data() {
    return {
      id: '',
      voice: null,
      admin: false
    };
  },
  methods: {
    getVoice() {
      return axios
        .get(`${APIUrl}/api/voices/${this.id}`)
        .then(res => {
          this.voice = res.data;
        })
        .catch(error => {
          // eslint-disable-next-line
          console.error(error);
          return error;
        });
    },
    moveToTop() {
      axios
        .put(`${APIUrl}/api/voices/${this.id}?moveToTop=true`)
        .then(res => {
          console.log(res.data);
          // TODO: replace route
          this.$router.go(-1);
        })
        .catch(error => {
          // eslint-disable-next-line
          console.error(error);
        });
    },
    moveToBottom() {
      axios
        .put(`${APIUrl}/api/voices/${this.id}?moveToBottom=true`)
        .then(res => {
          console.log(res.data);
          // TODO: replace route
          this.$router.go(-1);
        })
        .catch(error => {
          // eslint-disable-next-line
          console.error(error);
        });
    },
    deleteVoice() {
      axios
        .delete(`${APIUrl}/api/voices/${this.id}`)
        .then(() => {
          // TODO: replace route
          this.$router.go(-1);
        })
        .catch(error => {
          // eslint-disable-next-line
          console.error(error);
        });
    }
  },
  created() {
    this.admin = this.$route.query.admin;
    this.id = this.$route.params.id;
    this.getVoice();
  },
  beforeRouteUpdate(to, next) {
    this.id = to.params.id;
    this.getVoice().then(next);
  },
  directives: {
    linkified: linkify
  }
};
</script>
